import React, { Fragment } from "react";
import {
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Row,
} from "reactstrap";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import BaseInput from "../../../toolkit/baseInput";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/withStyles";
import BaseSelect from "../../../toolkit/baseSelect";
import s from "./styles.scss";
import {
  ModalProps,
  serviceCaller,
  ServiceCallerProps,
  withLoginRedirect,
  withModals,
} from "../../composition";
import Reform from "@franleplant/reform";
import firebase from "firebase/compat/app";
import { isCurrentUserAdmin } from "../../../utils/roleCheck";
import emailValidator from "email-validator";
import phone from "phone";
import isEmpty from "lodash.isempty";
import {
  createUser,
  deleteUser,
  executeForgotPassword,
  resendAdminInvite,
  searchUserByEmail,
  searchUsersById,
  updateUser,
  upsertThankYouAdminGlobal,
} from "../../../utils/fetch";
import IExtendedUser from "../../../types/services/IExtendedUser";
import { ScaleLoader } from "react-spinners";
import * as commonActions from "../../../utils/actions/common";
import ThresholdFields, {
  BLANK_THRESHOLDS,
  readThresholds,
  ThresholdState,
} from "../thankYouAdmins/thresholdFields";

interface Recipient<T> {
  label: string;
  value: string;
  object: T;
}

import { selectUsesGiveSpark } from "../../../utils/giveSpark";
interface Props extends ServiceCallerProps, ModalProps {
  usesGiveSpark: boolean;
  userId: string;
  firebase: firebase.app.App;
  hideSelection: () => void;
  isSuperadmin?: boolean;
}

type DisplayState = "requestEmail" | "normal" | "loading";

interface State {
  userId?: string;
  fields: {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    email: string;
    role: Recipient<string>;
    photoUrl: string;
  };
  currentUser: IExtendedUser;
  displayState: DisplayState;
  errors: any;
  errorMessage: string;
  formValid: boolean;
  roles: Recipient<string>[];
  busyLoading: "save" | "delete" | null;
  onboardingAdmin: boolean;
  addToGlobalThankYou: boolean;
  thankYouFields: ThresholdState;
  actionsMenuOpen: boolean;
}

class UserDetail extends React.PureComponent<Props, State> {
  re = Reform.reactMixins.objectMixin(this);

  constructor(props: Props) {
    super(props);
    this.state = {
      fields: {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        role: null,
        photoUrl: "",
      },
      displayState: "requestEmail",
      errors: {},
      formValid: false,
      busyLoading: null,
      currentUser: null,
      errorMessage: "",
      onboardingAdmin: false,
      addToGlobalThankYou: false,
      thankYouFields: BLANK_THRESHOLDS,
      actionsMenuOpen: false,
      roles: [
        {
          label: "Admin",
          value: "Admin",
          object: "ADMIN",
        },
        {
          label: "Publisher",
          value: "Publisher",
          object: "PUBLISHER",
        },
        {
          label: "Contributor",
          value: "Contributor",
          object: "COLLABORATOR",
        },
        {
          label: "Read-Only",
          value: "Read-Only",
          object: "READER",
        },
      ],
    };
  }

  validationRules = {
    firstName: { required: true },
    lastName: { required: true },
    email: {
      email: val => {
        return !emailValidator.validate(val);
      },
    },
    phoneNumber: {
      phoneNumber: val => {
        return val !== "" && !phone(val, { country: "USA" }).isValid;
      },
    },
    role: { required: true },
  };

  validationMessages = {
    required: () => `Required`,
    email: () => "Please, enter a valid email",
    phoneNumber: () => "Please, enter a valid mobile",
    check: () => `Required`,
    default: () => `Invalid`,
  };

  uppercaseFirstLetter = text => {
    return text.charAt(0).toUpperCase() + text.substr(1);
  };

  componentDidMount() {
    this.props.hideSelection();
    if (window) {
      window.scrollTo(0, 0);
    }
    this.checkUserById();
  }

  componentDidUpdate() {
    if (!this.state.currentUser && this.state.displayState === "requestEmail") {
      this.checkUserById();
    }
  }

  resetPassword = () => {
    executeForgotPassword(this.props.config.authServiceUrl, {
      email: this.state.fields.email,
    }).then(response => {
      alert(response);
    });
  };

  resendInvite = () => {
    resendAdminInvite(
      this.props.config.authServiceUrl,
      this.props.serviceAccessToken,
      this.props.params.userId,
      this.props.currentCharity.id
    ).then(response => {
      alert(response);
    });
  };

  checkUserById = () => {
    if (
      this.props.config &&
      this.props.currentCharity &&
      this.props.serviceAccessToken &&
      this.props.params.userId
    ) {
      this.setState(
        {
          displayState: "loading",
        },
        () => {
          searchUsersById(
            this.props.config.searchServiceUrl,
            this.props.currentCharity.id,
            [this.props.params.userId],
            this.props.serviceAccessToken
          ).then(response => {
            if (!isEmpty(response)) {
              this.setState(
                {
                  currentUser: response,
                },
                () => {
                  this.fillUserValues();
                }
              );
            } else {
              this.props.navigate("/users");
            }
          });
        }
      );
    }
  };

  onValidation = fieldName => {
    return event => {
      let value = event.target.value;
      if (fieldName === "firstName" || fieldName === "lastName") {
        value = this.uppercaseFirstLetter(value);
      }
      if (fieldName === "email") {
        value = value.toLowerCase();
      }
      this.setState(
        state => {
          const fields = {
            ...state.fields,
            [fieldName]: value,
          };
          if (fieldName === "email" || fieldName === "phoneNumber") {
            this.re.validateField(fieldName, value);
          }
          return { ...state, error: {}, fields };
        },
        () =>
          this.setState({
            formValid: this.re.formIsValid(),
          })
      );
    };
  };

  onValidateSelect = fieldName => {
    return selection => {
      this.setState(
        state => {
          const fields = {
            ...state.fields,
            [fieldName]: selection,
          };
          this.re.validateField(fieldName, selection);
          return { ...state, error: {}, fields };
        },
        () =>
          this.setState({
            formValid: this.re.formIsValid(),
          })
      );
    };
  };

  checkEmailForNext = () => {
    this.setState(
      {
        displayState: "loading",
      },
      () => {
        this.checkAndFillAdmin();
      }
    );
  };

  checkAndFillAdmin = () => {
    if (
      this.props.config &&
      this.props.currentCharity &&
      this.props.serviceAccessToken
    ) {
      searchUserByEmail(
        this.props.config.authServiceUrl,
        this.props.currentCharity.id,
        this.state.fields.email,
        this.props.serviceAccessToken
      ).then(response => {
        if (!isEmpty(response)) {
          this.setState(
            {
              currentUser: response,
            },
            () => {
              this.fillUserValues();
            }
          );
        } else {
          this.setState({
            displayState: "normal",
          });
        }
      });
    }
  };

  canBeThankYouAdmin = () => {
    const role = this.state.fields.role && this.state.fields.role.object;
    return role === "ADMIN" || role === "PUBLISHER";
  };

  createUser = () => {
    if (this.state.formValid) {
      const addToGlobalThankYou =
        this.state.addToGlobalThankYou &&
        this.canBeThankYouAdmin() &&
        this.props.usesGiveSpark;
      const thresholds = addToGlobalThankYou
        ? readThresholds(this.state.thankYouFields)
        : null;
      if (addToGlobalThankYou && thresholds === null) {
        this.setState({
          errorMessage:
            "Thank-you amounts must be whole dollars, and each maximum must be at least its minimum.",
        });
        return;
      }
      this.setState(
        {
          busyLoading: "save",
          errorMessage: "",
        },
        () => {
          createUser(
            this.props.config.authServiceUrl,
            this.props.serviceAccessToken,
            {
              realm: this.props.currentCharity.id,
              name:
                this.state.fields.firstName + " " + this.state.fields.lastName,
              firstName: this.state.fields.firstName,
              lastName: this.state.fields.lastName,
              phoneNumber:
                this.state.fields.phoneNumber !== ""
                  ? phone(this.state.fields.phoneNumber, { country: "USA" })
                      .phoneNumber
                  : null,
              email: this.state.fields.email,
              role: this.state.fields.role.object,
              onboardingOperator:
                this.state.onboardingAdmin &&
                this.state.fields.role.object === "ADMIN",
            }
          )
            .then(response => {
              const finishCreate = (message: string) => {
                setTimeout(() => {
                  if (response === "Success") {
                    alert(message);
                    this.props.navigate("/users");
                  } else {
                    this.setState({
                      errorMessage: response,
                      busyLoading: null,
                    });
                  }
                }, 3000);
              };
              if (response !== "Success" || !addToGlobalThankYou) {
                finishCreate(
                  "The user was created successfully. \n A welcome email was sent to the user."
                );
                return;
              }
              searchUserByEmail(
                this.props.config.authServiceUrl,
                this.props.currentCharity.id,
                this.state.fields.email,
                this.props.serviceAccessToken
              )
                .then(created => {
                  if (!created || !created.id) {
                    throw new Error("lookup failed");
                  }
                  return upsertThankYouAdminGlobal(
                    this.props.config.adminServiceUrl,
                    this.props.currentCharity.id,
                    created.id,
                    this.props.serviceAccessToken,
                    thresholds.threshold,
                    thresholds.firstMonthlyThreshold,
                    thresholds.maxThreshold,
                    thresholds.maxFirstMonthlyThreshold
                  );
                })
                .then(() => {
                  finishCreate(
                    "The user was created successfully. \n A welcome email was sent to the user."
                  );
                })
                .catch(() => {
                  finishCreate(
                    "The user was created successfully, but the Global thank-you assignment could not be saved. Add them from the Users list."
                  );
                });
            })
            .catch(error => {
              this.setState({ errorMessage: error.message, busyLoading: null });
            });
        }
      );
    }
  };

  updateUser = () => {
    if (this.state.formValid) {
      this.setState(
        {
          busyLoading: "save",
        },
        () => {
          updateUser(
            this.props.config.authServiceUrl,
            this.props.serviceAccessToken,
            {
              realm: this.props.currentCharity.id,
              name:
                this.state.fields.firstName + " " + this.state.fields.lastName,
              firstName: this.state.fields.firstName,
              lastName: this.state.fields.lastName,
              phoneNumber:
                this.state.fields.phoneNumber !== ""
                  ? phone(this.state.fields.phoneNumber, { country: "USA" })
                      .phoneNumber
                  : null,
              email: this.state.fields.email,
              role: this.state.fields.role.object,
              userId: this.props.params.userId,
            }
          )
            .then(response => {
              setTimeout(() => {
                if (response === "Success") {
                  alert("The user has been updated.");
                  this.props.navigate("/users");
                } else {
                  this.setState({ errorMessage: response, busyLoading: null });
                }
              }, 3000);
            })
            .catch(error => {
              this.setState({ errorMessage: error.message, busyLoading: null });
            });
        }
      );
    }
  };

  deleteUser = () => {
    if (confirm("Are you sure you want to delete this user?")) {
      deleteUser(
        this.props.config.authServiceUrl,
        this.props.serviceAccessToken,
        this.props.params.userId,
        this.props.currentCharity.id
      ).then(response => {
        setTimeout(() => {
          if (response === "Success") {
            alert("The user has been deleted.");
            this.props.navigate("/users");
          } else {
            this.setState({ errorMessage: response });
          }
        }, 3000);
      });
    }
  };

  fillUserValues = () => {
    this.setState(
      {
        fields: {
          firstName: this.state.currentUser.firstName
            ? this.state.currentUser.firstName
            : "",
          lastName: this.state.currentUser.lastName
            ? this.state.currentUser.lastName
            : "",
          phoneNumber: this.state.currentUser.phoneNumber
            ? this.state.currentUser.phoneNumber
            : "",
          email: this.state.currentUser.email,
          role: {
            label: this.state.currentUser.rolePretty,
            value: this.state.currentUser.rolePretty,
            object: this.state.currentUser.role,
          },
          photoUrl: this.state.currentUser.photoUrl
            ? this.state.currentUser.photoUrl
            : "",
        },
        displayState: "normal",
      },
      () => {
        this.setState({
          formValid: this.re.formIsValid(),
        });
      }
    );
  };

  resetForm = () => {
    this.props.navigate("/users");
  };

  toggleActionsMenu = () => {
    this.setState({ actionsMenuOpen: !this.state.actionsMenuOpen });
  };

  render() {
    return (
      <main className={s.main}>
        <div className={s.container}>
          <Row>
            {this.state.fields.photoUrl !== "" && (
              <Col md={{ size: 2, offset: 2 }} xs={3}>
                <img src={this.state.fields.photoUrl} className={s.photo} />
              </Col>
            )}
            <Col
              md={
                this.state.fields.photoUrl !== "" ? 7 : { size: 8, offset: 2 }
              }
              xs={8}
              className={s.firstMargin}
            >
              <div className={s.titleRow}>
                <h2>{this.props.params.userId ? "Edit User" : "New User"}</h2>
                {this.props.params.userId && (
                  <div className={s.titleActions}>
                    <Button
                      outline
                      className={s.formToolbarSecondary}
                      disabled={!this.props.usesGiveSpark}
                      onClick={() =>
                        this.props.navigate(
                          `/users/${this.props.params.userId}/thank-you-admins`
                        )
                      }
                    >
                      Thank You Segments
                    </Button>
                    {isCurrentUserAdmin(this.props.currentCharity) && (
                      <Dropdown
                        isOpen={this.state.actionsMenuOpen}
                        toggle={this.toggleActionsMenu}
                      >
                        <DropdownToggle
                          color="link"
                          className={s.toolbarExtras}
                          aria-label="More actions"
                        >
                          <i className="fa fa-ellipsis-v" />
                        </DropdownToggle>
                        <DropdownMenu right className={s.actionsDropdownMenu}>
                          <DropdownItem
                            id="resetPasswordButton"
                            onClick={this.resendInvite}
                          >
                            Resend Invite
                          </DropdownItem>
                          <DropdownItem
                            id="resetPasswordButton"
                            onClick={this.resetPassword}
                          >
                            Reset Password
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    )}
                  </div>
                )}
              </div>
            </Col>
          </Row>
          {this.state.displayState === "requestEmail" && (
            <Row>
              <Col md={{ size: 8, offset: 2 }}>
                <Row>
                  <Col xs={12}>
                    <FormGroup>
                      <label className={s.titleLabel} htmlFor="email">
                        Email
                        {this.re
                          .mapFieldErrors("email")
                          .map((message, index) => {
                            return (
                              <span key={index} className={s.error}>
                                {message}
                              </span>
                            );
                          })}
                      </label>
                      <BaseInput
                        type="text"
                        name="email"
                        id="email"
                        value={this.state.fields.email}
                        onChange={this.onValidation("email")}
                        disabled={
                          !isCurrentUserAdmin(this.props.currentCharity)
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className={s.formToolbarCol}>
                    <div className={s.formToolbarBar}>
                      <div className={s.formToolbarCancelWrap}>
                        <Button
                          id={"cancelBackButton"}
                          color="link"
                          onClick={this.resetForm}
                          className={s.formToolbarCancel}
                        >
                          Back
                        </Button>
                      </div>
                      {isCurrentUserAdmin(this.props.currentCharity) && (
                        <div className={s.formToolbarActionGroup}>
                          <Button
                            id={"nextButton"}
                            color="primary"
                            onClick={this.checkEmailForNext}
                            className={s.formToolbarPrimary}
                            disabled={
                              !isCurrentUserAdmin(this.props.currentCharity) ||
                              !emailValidator.validate(this.state.fields.email)
                            }
                          >
                            Next
                          </Button>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
          {this.state.displayState === "normal" && (
            <Fragment>
              <Row>
                <Col md={{ size: 8, offset: 2 }}>
                  <Row>
                    <Col sm={12}>
                      <FormGroup>
                        <label className={s.titleLabel} htmlFor="email">
                          * Email
                          {this.re
                            .mapFieldErrors("email")
                            .map((message, index) => {
                              return (
                                <span key={index} className={s.error}>
                                  {message}
                                </span>
                              );
                            })}
                        </label>
                        <BaseInput
                          type="text"
                          name="email"
                          id="email"
                          value={this.state.fields.email}
                          onChange={this.onValidation("email")}
                          disabled={true}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <FormGroup>
                        <label className={s.titleLabel} htmlFor="firstName">
                          * First Name
                          {this.re
                            .mapFieldErrors("firstName")
                            .map((message, index) => {
                              return (
                                <span key={index} className={s.error}>
                                  {message}
                                </span>
                              );
                            })}
                        </label>
                        <BaseInput
                          type="text"
                          name="firstName"
                          id="firstName"
                          value={this.state.fields.firstName}
                          onChange={this.onValidation("firstName")}
                          disabled={
                            (!this.props.params.userId &&
                              this.state.currentUser) ||
                            !isCurrentUserAdmin(this.props.currentCharity)
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={6}>
                      <FormGroup>
                        <label className={s.titleLabel} htmlFor="lastName">
                          * Last Name
                          {this.re
                            .mapFieldErrors("lastName")
                            .map((message, index) => {
                              return (
                                <span key={index} className={s.error}>
                                  {message}
                                </span>
                              );
                            })}
                        </label>
                        <BaseInput
                          type="text"
                          name="lastName"
                          id="lastName"
                          value={this.state.fields.lastName}
                          onChange={this.onValidation("lastName")}
                          disabled={
                            (!this.props.params.userId &&
                              this.state.currentUser) ||
                            !isCurrentUserAdmin(this.props.currentCharity)
                          }
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <FormGroup>
                        <label className={s.titleLabel} htmlFor="role">
                          * Role
                        </label>
                        <BaseSelect
                          id={"roleSelect"}
                          name={"roleSelect"}
                          dataElmId={"roleSelect"}
                          placeholder={"Select Role..."}
                          options={this.state.roles}
                          onChange={this.onValidateSelect("role")}
                          value={this.state.fields.role}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={6}>
                      <FormGroup>
                        <label className={s.titleLabel} htmlFor="phoneNumber">
                          Phone Number
                          {this.re
                            .mapFieldErrors("phoneNumber")
                            .map((message, index) => {
                              return (
                                <span key={index} className={s.error}>
                                  {message}
                                </span>
                              );
                            })}
                        </label>
                        <BaseInput
                          type="text"
                          name="phoneNumber"
                          id="phoneNumber"
                          value={this.state.fields.phoneNumber}
                          onChange={this.onValidation("phoneNumber")}
                          disabled={
                            (!this.props.params.userId &&
                              this.state.currentUser) ||
                            !isCurrentUserAdmin(this.props.currentCharity)
                          }
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  {!this.props.params.userId &&
                    this.props.isSuperadmin &&
                    this.state.fields.role?.object === "ADMIN" && (
                      <Row>
                        <Col sm={12}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={this.state.onboardingAdmin}
                                  onChange={(_, checked) =>
                                    this.setState({ onboardingAdmin: checked })
                                  }
                                  color="primary"
                                />
                              }
                              label="Onboarding admin"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    )}
                  {!this.props.params.userId &&
                    isCurrentUserAdmin(this.props.currentCharity) &&
                    this.canBeThankYouAdmin() && (
                      <Row>
                        <Col sm={12}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={this.state.addToGlobalThankYou}
                                  disabled={!this.props.usesGiveSpark}
                                  onChange={(_, checked) =>
                                    this.setState({
                                      addToGlobalThankYou: checked,
                                    })
                                  }
                                  color="primary"
                                />
                              }
                              label="Add to Global thank-you users"
                            />
                          </FormGroup>
                        </Col>
                        {this.state.addToGlobalThankYou && (
                          <Col sm={12}>
                            <ThresholdFields
                              idPrefix="newUserThankYou"
                              fields={this.state.thankYouFields}
                              disabled={this.state.busyLoading !== null}
                              onChange={thankYouFields =>
                                this.setState({ thankYouFields })
                              }
                            />
                          </Col>
                        )}
                      </Row>
                    )}
                  {this.state.errorMessage.length > 0 && (
                    <Row className={s.centered}>
                      <span className={s.error}>{this.state.errorMessage}</span>
                    </Row>
                  )}
                </Col>
              </Row>
              <Row className={s.firstMargin}>
                <Col md={{ size: 8, offset: 2 }}>
                  <span className={s.requiredText}>* Required</span>
                  <hr style={{ clear: "right" }} />
                </Col>
              </Row>
              <Row>
                <Col
                  className={s.formToolbarCol}
                  sm={12}
                  md={{ size: 8, offset: 2 }}
                >
                  <div className={s.formToolbarBar}>
                    <div className={s.formToolbarCancelWrap}>
                      <Button
                        id={"cancelBackButton"}
                        color="link"
                        onClick={this.resetForm}
                        className={s.formToolbarCancel}
                      >
                        {isCurrentUserAdmin(this.props.currentCharity)
                          ? "Cancel"
                          : "Back"}
                      </Button>
                    </div>
                    {isCurrentUserAdmin(this.props.currentCharity) && (
                      <div className={s.formToolbarActionGroup}>
                        {this.props.params.userId && (
                          <Button
                            id={"deleteUserButton"}
                            outline
                            onClick={this.deleteUser}
                            className={s.formToolbarSecondary}
                          >
                            Delete User
                          </Button>
                        )}
                        {this.props.params.userId && (
                          <Button
                            id={"saveButton"}
                            color="primary"
                            className={s.formToolbarPrimary}
                            disabled={
                              this.state.busyLoading !== null ||
                              !this.state.formValid
                            }
                            onClick={this.updateUser}
                          >
                            {this.state.busyLoading === "save" ? (
                              <i className="fa fa-spinner fa-spin">&nbsp;</i>
                            ) : (
                              "Update"
                            )}
                          </Button>
                        )}
                        {!this.props.params.userId && (
                          <Button
                            id={"createButton"}
                            color="primary"
                            className={s.formToolbarPrimary}
                            disabled={
                              this.state.busyLoading !== null ||
                              !this.state.formValid
                            }
                            onClick={this.createUser}
                          >
                            {this.state.busyLoading === "save" ? (
                              <i className="fa fa-spinner fa-spin">&nbsp;</i>
                            ) : (
                              "Create"
                            )}
                          </Button>
                        )}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </Fragment>
          )}
          {this.state.displayState === "loading" && (
            <div className={s.loader}>
              <ScaleLoader color={"#1f65b1"} loading />
            </div>
          )}
        </div>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  hideSelection: () => {
    dispatch(commonActions.hideSelection());
  },
});

export default serviceCaller(
  withLoginRedirect(
    connect(
      state => ({ usesGiveSpark: selectUsesGiveSpark(state) }),
      mapDispatchToProps
    )(withModals(withStyles(s)(UserDetail)))
  )
);
